import type { NotifyPort } from '@/features/messages/domain/notify'
import type { ChatMember, ChatPort } from '../domain/chat'

const listSubscriptions = async (port: ChatPort, topicId: string, notify: NotifyPort): Promise<ChatMember[]> => {
	try {
		return await port.listSubscriptions(topicId)
	} catch {
		notify.error('chat.membersLoadFailed')
		return []
	}
}

const listMembers = async (port: ChatPort, query: string | null, notify: NotifyPort): Promise<ChatMember[]> => {
	try {
		return await port.listMembers(query)
	} catch {
		notify.error('chat.membersLoadFailed')
		return []
	}
}

const addMember = async (port: ChatPort, topicId: string, userId: string, notify: NotifyPort): Promise<boolean> => {
	try {
		await port.addMember(topicId, userId)
		notify.success('chat.memberAdded')
		return true
	} catch {
		notify.error('chat.memberAddFailed')
		return false
	}
}

const removeMember = async (port: ChatPort, topicId: string, userId: string, notify: NotifyPort): Promise<boolean> => {
	try {
		await port.removeMember(topicId, userId)
		notify.success('chat.memberRemoved')
		return true
	} catch {
		notify.error('chat.memberRemoveFailed')
		return false
	}
}

export { listSubscriptions, listMembers, addMember, removeMember }
